import { saveAs } from 'file-saver';

export function Base64ToArrayBuffer(base64: string) {
    const binaryString = window.atob(base64);
    const binaryLen = binaryString.length;
    const bytes = new Uint8Array(binaryLen);
    for (let i = 0; i < binaryLen; i++) {
        const ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
    }
    return bytes;
}

export function SaveByteArray(fileName: string, byte: BlobPart) {
    const blob = new Blob([byte]);
    
    if(fileName && !fileName.includes('.')) {
        fileName = fileName + ".pdf";
    }

    saveAs(blob, fileName);
}

/**
 * Accepts a Base64 string, and converts it into a JS Blob object.
 * @param base64 
 */
export function Base64ToJavaScriptBlob(base64: string): Blob {
    const stream = Base64ToArrayBuffer(base64);
    const blob = new Blob([stream]);
    return blob;
}